module.exports = __webpack_public_path__ + "static/img/WMSTitle.7c64081.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/WMSTitle.png
// module id = m7BF
// module chunks = 58